import { ContainerModule } from 'inversify';
import DataroomTenantConfig from '@/dataroom/application/config/DataroomTenantConfig';
import { DataroomTenant } from '@/dataroom/domain/vo/types/DataroomTenant';
import { TYPES } from '@/Framework/config/DI/types';
import { ConfigFactory } from './ConfigFactory';

export const configModule: ContainerModule = new ContainerModule((bind) => {
  bind(TYPES.AppConfig).toDynamicValue(({ container }) => {
    const hostname = container.get<string>(TYPES.Hostname);
    const tenant: DataroomTenant = DataroomTenantConfig.fromHostname(hostname).code;

    const factory = container.get<ConfigFactory>(ConfigFactory);
    return factory.create(tenant);
  });
});
